export default __webpack_public_path__ + "static/Upper-6e46c29ce31fae26b9f21d5f2c47458e.svg";